import React from 'react';
import Dashboard from './Dashboard';

function App() {
  const programId = '3xhezws6Lk7cMqoVEfZFXu3ry9GKymFz1vbWyQ4f99uX'; // Replace with your specific programId

  return (
    <div className="App">
      <Dashboard programId={programId} />
    </div>
  );
}

export default App;